import { type IntlShape } from 'react-intl-next/src/types';

import { messages as commonMessages } from '../../../common/messages';
import { OverrideVariant } from '../../../controllers/page-store/state/types';

export const confirmTextButtons = (intlApi: IntlShape) => ({
	[OverrideVariant.Edit]: intlApi.formatMessage(commonMessages.saveButton),
	[OverrideVariant.Add]: intlApi.formatMessage(commonMessages.overrideButton),
	[OverrideVariant.Customize]: intlApi.formatMessage(commonMessages.saveButton),
});
